const CLIENT_SEARCH = 1;
const CLIENT_NOTES_SEARCH = 4;
const TRACKING_HISTORY_SEARCH = 5;
const PUBLIC_INTAKE_SUBMISSIONS = 6;

export {
    CLIENT_SEARCH,
    CLIENT_NOTES_SEARCH,
    TRACKING_HISTORY_SEARCH,
    PUBLIC_INTAKE_SUBMISSIONS
}